import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaginatorComponent} from './paginator.component';
import {HttpClientModule} from '@angular/common/http';
import {PaginatorService} from './paginator.service';
import {EventsService} from './event.service';
export class LarangPaginatorModule {
/**
 * @return {?}
 */
static forRoot() {
    return {
      ngModule: LarangPaginatorModule,
      providers: [PaginatorService, EventsService]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [PaginatorComponent],
  exports: [PaginatorComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LarangPaginatorModule_tsickle_Closure_declarations() {
/** @type {?} */
LarangPaginatorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LarangPaginatorModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
